import { styled } from '@mui/material/styles';
import { InputLabel } from '@mui/material';

export const RedAsteriskLabel = styled(InputLabel)({
    '& .MuiInputLabel-asterisk': {
        color: 'red'
    }
});
